import type { Note } from "@school-sales-ai/shared";

type Props = { notes: Note[] };

function formatDate(iso: string): string {
  return new Date(iso).toLocaleString("es-MX", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function NotesList({ notes }: Props): React.JSX.Element {
  if (notes.length === 0) {
    return (
      <p className="text-sm text-ink-300 text-center py-4">No hay notas aún.</p>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {notes.map((note) => (
        <div key={note.id} className="bg-ink-050 rounded-lg p-3">
          <div className="flex items-center justify-between gap-2 mb-1">
            <span className="text-xs font-semibold text-ink-500 truncate">
              {note.authorName}
            </span>
            <span className="text-xs text-ink-300 shrink-0">
              {formatDate(note.createdAt)}
            </span>
          </div>
          <p className="text-sm text-ink-700 whitespace-pre-wrap break-words">
            {note.content}
          </p>
        </div>
      ))}
    </div>
  );
}
